import { BasePage } from "@Tenants/Fun/Site/BasePage";
import "./HalloweenHero.scss";

class HalloweenHero extends BasePage
{
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	};
}

const halloweenHero = new HalloweenHero();